import { render, staticRenderFns } from "./wordpressPlugin.vue?vue&type=template&id=b4f79f9c&scoped=true"
import script from "./wordpressPlugin.vue?vue&type=script&lang=js"
export * from "./wordpressPlugin.vue?vue&type=script&lang=js"
import style0 from "./wordpressPlugin.vue?vue&type=style&index=0&id=b4f79f9c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4f79f9c",
  null
  
)

export default component.exports